export const fieldUser = [
    {
        id:"customerName",
        name:"customerName", 
        label:"Customer Name",
        type:"select",
    },
    {
        id:"location",
        name:"location", 
        label:"Location",
        type:"input",
        inputType:"text",
    },
    {
        id:"address",
        name:"address", 
        label:"Address",
        type:"input",
        inputType:"text",
    },
    {
        id:"buildingPersonnel",
        name:"buildingPersonnel", 
        label:"Building Personal",
        type:"multiselect",
    },
]
